import type { SVGProps } from 'react'

const SvgArroIconOnlyTop: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.13454 4.96988L5.04454 2.05988L7.95454 4.96988C8.09802 5.09275 8.28257 5.15695 8.47133 5.14966C8.66009 5.14237 8.83914 5.06412 8.97271 4.93055C9.10628 4.79698 9.18453 4.61793 9.19182 4.42917C9.19911 4.24041 9.13491 4.05586 9.01204 3.91238L5.56954 0.469879C5.42902 0.330191 5.23893 0.251784 5.04079 0.251784C4.84265 0.251784 4.65256 0.330191 4.51204 0.469879L1.06954 3.91238C0.929852 4.0529 0.851444 4.24299 0.851444 4.44113C0.851444 4.63927 0.929852 4.82936 1.06954 4.96988C1.21199 5.10878 1.40308 5.18652 1.60204 5.18652C1.801 5.18652 1.99209 5.10878 2.13454 4.96988Z"
      fill="currentColor"
    />
  </svg>
)

export default SvgArroIconOnlyTop
